export default __webpack_public_path__ + "static/media/register 1024.e7c83542.svg";